export interface PasswordChecks {
  length: boolean;
  lowercase: boolean;
  uppercase: boolean;
  number: boolean;
  special: boolean;
  consecutive: boolean;
}

export interface PasswordValidationResult {
  valid: boolean;
  checks: PasswordChecks;
}

const SPECIAL_REGEX = /[^A-Za-z0-9]/;
const LOWER_REGEX = /[a-z]/;
const UPPER_REGEX = /[A-Z]/;
const NUMBER_REGEX = /\d/;
const TRIPLE_CONSECUTIVE_REGEX = /(.)\1\1/;

export function validateSftpUserPassword(pwd: string): PasswordValidationResult {
  const checks: PasswordChecks = {
    length: pwd.length >= 9,
    lowercase: LOWER_REGEX.test(pwd),
    uppercase: UPPER_REGEX.test(pwd),
    number: NUMBER_REGEX.test(pwd),
    special: SPECIAL_REGEX.test(pwd),
    consecutive: !TRIPLE_CONSECUTIVE_REGEX.test(pwd),
  };
  return { valid: Object.values(checks).every(Boolean), checks };
}

export function passwordCheckMessages(
  checks: PasswordChecks,
): Array<{ key: keyof PasswordChecks; label: string; passed: boolean }> {
  return [
    { key: 'length', label: 'At least 9 characters', passed: checks.length },
    { key: 'lowercase', label: 'Contains lowercase letter', passed: checks.lowercase },
    { key: 'uppercase', label: 'Contains uppercase letter', passed: checks.uppercase },
    { key: 'number', label: 'Contains a number', passed: checks.number },
    { key: 'special', label: 'Contains special character', passed: checks.special },
    {
      key: 'consecutive',
      label: 'No more than 2 identical consecutive characters',
      passed: checks.consecutive,
    },
  ];
}
